module.exports = __webpack_public_path__ + "media/images/patterns/circles-71b8196a4c8a4dab7e0d0cc09e8f6c4a.svg";